import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { NAV } from "../../mock/mockData";
import { useSiteContent } from "../../context/SiteContentProvider";

const DesktopNav = ({ navItems, hovered, setHovered }) => {
  const { locationGroups } = useSiteContent();
  return (
  <nav className="hidden lg:flex items-center gap-9 absolute left-1/2 -translate-x-1/2">
    {navItems.map((item) => (
      <div
        key={item.label}
        className="relative h-[72px] flex items-center"
        onMouseEnter={() => setHovered(item.menu)}
        onMouseLeave={() => setHovered(null)}
      >
        <Link
          to={item.to}
          className="label-caps text-[11px] text-ink flex items-center gap-1 hover:text-camel transition-colors"
        >
          {item.label}
          {item.menu && <ChevronDown className="w-3 h-3" />}
        </Link>
        {item.menu && hovered === item.menu && (
          <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 z-50">
            <div className="bg-white rounded-2xl shadow-xl border border-line py-3 min-w-[260px] overflow-hidden">
              {item.menu === "locations"
                ? locationGroups.map((group) => (
                    <div key={group.city} className="py-1">
                      <p className="px-5 pt-2 pb-1 label-caps text-[9px] text-camel">{group.city}</p>
                      {group.items.map((sub) => (
                        <Link
                          key={sub.id}
                          to={`/locations/${sub.id}`}
                          className={`flex items-center justify-between gap-2 px-5 py-2 text-[13px] transition-colors ${
                            sub.acceptingMembers
                              ? "text-ink-soft hover:text-camel hover:bg-sand"
                              : "text-ink-soft/40 hover:bg-sand"
                          }`}
                        >
                          <span>{sub.name}</span>
                          {!sub.acceptingMembers && (
                            <span className="label-caps text-[8px] px-1.5 py-0.5 rounded-full bg-line text-ink-soft/60">Full</span>
                          )}
                        </Link>
                      ))}
                    </div>
                  ))
                : NAV.memberships.map((sub) => (
                    <Link
                      key={sub.slug}
                      to={`/memberships/${sub.slug}`}
                      className="block px-5 py-2.5 text-[13px] text-ink-soft hover:text-camel hover:bg-sand transition-colors"
                    >
                      {sub.name}
                    </Link>
                  ))}
            </div>
          </div>
        )}
      </div>
    ))}
  </nav>
  );
};

export default DesktopNav;
